import { render, staticRenderFns } from "./MyRenewAffiliateRequest.vue?vue&type=template&id=5ed3cfb0"
import script from "./MyRenewAffiliateRequest.vue?vue&type=script&lang=ts"
export * from "./MyRenewAffiliateRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports